"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceCalculator = void 0;
class DistanceCalculator {
    /**
     * Calculate the distance between two coordinates.
     *
     * @param {ILocation} from
     * @param {ILocation} to
     * @returns {number}
     */
    static calculateDistance(from, to) {
        from = DistanceCalculator.bothDegreesToRadian(from);
        to = DistanceCalculator.bothDegreesToRadian(to);
        const earthRadius = 6371;
        const delta = {
            lat: to.lat - from.lat,
            lon: to.lon - from.lon
        };
        const value = Math.pow(Math.sin(delta.lat / 2), 2) +
            Math.pow(Math.sin(delta.lon / 2), 2) *
                Math.cos(from.lat);
        const angle = 2 * Math.asin(Math.sqrt(value));
        return angle * earthRadius;
    }
    /**
     * Convert a value from degree to radian.
     *
     * @param value
     */
    static degreeToRadian(value) {
        return value * Math.PI / 180;
    }
    /**
     * Perform the same conversion from degree to radian of a latitude and
     * longitude value.
     *
     * @param {ILocation} set
     * @returns {ILocation}
     */
    static bothDegreesToRadian(set) {
        return {
            lat: DistanceCalculator.degreeToRadian(set.lat),
            lon: DistanceCalculator.degreeToRadian(set.lon)
        };
    }
}
exports.DistanceCalculator = DistanceCalculator;
